import { Box, SxProps, Typography } from '@mui/material';

const containerStyle: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  width: '100%',
  padding: '15px 0',
};

const boxStyle: SxProps = {
  flex: 1,
  width: '50%',
  padding: '5px 5px 5px 0',
};

const innerBoxStyle: SxProps = {
  display: 'flex',
  gap: '5px',
  flexDirection: 'column',
};

const titleStyle: SxProps = {
  fontWeight: 500,
  fontSize: '14px',
};

const listStyle: SxProps = {
  maxHeight: '200px',
  overflow: 'auto',
};

const paddingTopStyle: SxProps = {
  paddingTop: '20px',
};

const AssignmentConfirmDialog = ({
  madeAvailableDataSets,
  availableDataSets,
  madeUnavailableDataSets,
  availableDataSetsTitle,
  madeAvailableDataSetsTitle,
  madeUnavailableDataSetsTitle,
}: {
  madeAvailableDataSets: string[];
  availableDataSets: string[];
  madeUnavailableDataSets: string[];
  availableDataSetsTitle: string;
  madeAvailableDataSetsTitle: string;
  madeUnavailableDataSetsTitle: string;
}) => (
  <Box sx={containerStyle}>
    <Box sx={boxStyle}>
      <Box sx={innerBoxStyle}>
        <Typography component="h6" sx={titleStyle}>
          {madeAvailableDataSetsTitle}
        </Typography>
        <Box sx={listStyle}>
          {madeAvailableDataSets.map((dataSet, index) => (
            <Typography key={index} component="p" color="textPrimary">
              {dataSet}
            </Typography>
          ))}
        </Box>
      </Box>
      <Box sx={paddingTopStyle}>
        <Box sx={innerBoxStyle}>
          <Typography component="h6" sx={titleStyle}>
            {madeUnavailableDataSetsTitle}
          </Typography>
          <Box sx={listStyle}>
            {madeUnavailableDataSets.map((dataSet, index) => (
              <Typography key={index} component="p" color="textPrimary">
                {dataSet}
              </Typography>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
    <Box sx={boxStyle}>
      <Box sx={innerBoxStyle}>
        <Typography component="h6" sx={titleStyle}>
          {availableDataSetsTitle}
        </Typography>
        <Box sx={listStyle}>
          {availableDataSets.map((dataSet, index) => (
            <Typography key={index} component="p" color="textPrimary">
              {dataSet}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  </Box>
);

export default AssignmentConfirmDialog;
